import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import autobind from 'autobind-decorator';
import LineChartWithControls from 'components/visualization/line_chart_with_controls';
import { AppUI } from '@seedlang/state';
import PageTitle from 'components/common/page_title';

@observer
class CreatorDashboard extends React.Component {
  @observable chartSpecs = null;

  componentDidMount() {
    this.loadData();
  }

  @autobind loadData() {
    this.prepareChartSpecs();
  }

  @autobind async prepareChartSpecs() {
    const membershipTypes = await this.loadMembershipTypes();

    const resources = [];

    resources.push({
      label: 'Subscriptions',
      name: 'Analytic',
      date_field: 'date',
      scope: 'site',
      value_field: 'new_subscriptions_count',
      cumulative_value_field: 'total_subscriptions_count',
    });
    resources.push({
      label: 'Cancellations',
      name: 'Analytic',
      date_field: 'date',
      scope: 'site',
      value_field: 'cancellations_count',
      cumulative_value_field: 'cancellations_count',
    });
    membershipTypes.forEach(membershipType => (
      resources.push({
        label: `${membershipType.name} Subscriptions`,
        name: 'Analytic',
        date_field: 'date',
        scope: 'site',
        value_field: `new_subscriptions_counts_by_tier.${membershipType.id}`,
        cumulative_value_field: `total_subscriptions_counts_by_tier.${membershipType.id}`,
      })
    ));

    this.chartSpecs = [
      { name: 'Dashboard', resources },
    ];
  }

  get membershipTypes() {
    return AppUI.membershipTypeStore.indexData;
  }

  @autobind async loadMembershipTypes() {
    if (AppUI.membershipTypeStore.indexData.length === 0) {
      await AppUI.membershipTypeStore.getIndexPromise({});
    }
    return AppUI.membershipTypeStore.indexData.sort((a, b) => a.position - b.position);
  }

  render() {
    return (
      <>
        <PageTitle>Dashboard</PageTitle>
        <fieldset>
          {
            this.chartSpecs ? (
              <LineChartWithControls
                namespace='dashboard'
                charts={this.chartSpecs}
                defaultChartType='cumulative'
                defaultSelectedResources={['Subscriptions', 'Cancellations']}
              />
            ) : (
              <div>
                Loading...
              </div>
            )
          }
        </fieldset>
      </>
    );
  }
}

export default ErrorBoundary(CreatorDashboard);
